import request from '@/utils/request'

// 大屏进行中的订单
export function findProgressingServiceOrders(params) {
  return request({
    url: `/service_orders/progressing`,
    method: 'get',
    params: params
  })
}

export function findServiceOrder(id) {
  return request({
    url: `/service_orders/${id}`,
    method: 'get'
  })
}

export function findServiceOrderDirectorInfo(id) {
  return request({
    url: `/service_orders/${id}/director_info`,
    method: 'get'
  })
}

export function findServiceOrderConfirmNode(id) {
  return request({
    url: `/service_orders/${id}/confirm_node`,
    method: 'get'
  })
}

export function findTomorrowServiceOrderDirectorNodes(params) {
  return request({
    url: `/service_order_director_nodes/tomorrow`,
    method: 'get',
    params: params
  })
}
